import { AnchorHTMLAttributes } from 'react'

export const ExternalLink = (
  props: AnchorHTMLAttributes<HTMLAnchorElement>
) => (
  <a target="_blank" rel="noopener noreferrer nofollow external" {...props} />
)
